import type { HelpWidgetMessage } from "../types/help_widget_message";
import { formatMessageAsText } from "./messageTextFormatters";

const determineSpeakerName = (message: HelpWidgetMessage): string => {
  switch (message.author_type) {
    case "user":
      return message.author_name || "User";
    case "agent":
      return message.author_name
        ? `${message.author_name} (Circle)`
        : "Circle Support";
    case "bot":
      return "Copilot";
    case "system":
      return "System";
    default:
      return "Unknown";
  }
};

const formatMessageWithMetadata = (message: HelpWidgetMessage): string => {
  const messageTimestamp = new Date(message.created_at).toISOString();
  const formattedTimestamp = messageTimestamp.replace("T", " ").slice(0, 19);
  const speakerName = determineSpeakerName(message);
  const messageBody = formatMessageAsText(message);

  return `[${formattedTimestamp} UTC] ${speakerName}: ${messageBody}`;
};

export const generateTranscript = (messages: HelpWidgetMessage[]): string => {
  const formattedMessages = messages.map(formatMessageWithMetadata);
  return formattedMessages.join("\n\n");
};
